// File: PopularClassesSlider.jsx (Carousel + Inverted Triangles)
// Random fitness photos used safely as placeholders.

import React, { useState } from 'react';

import { ChevronRight, MonitorPlay, Notebook, Sailboat, SparkleIcon, ZapOff } from 'lucide-react';
const classesData = [
 { id: 1, title: 'IBPS', icon: <Sailboat size={30} color={`rgba(144, 202, 249,1)`}/> },
  { id: 2, title: 'NABARD', icon: <SparkleIcon size={30} color={`rgba(144, 202, 249,1)`}/> },
  { id: 3, title: 'SEBI', icon: <MonitorPlay size={30} color={`rgba(144, 202, 249,1)`}/> },
  { id: 4, title: 'RBI', icon: <Notebook size={30} color={`rgba(144, 202, 249,1)`}/> },
//   { id: 5, title: 'SBI', icon: <ZapOff size={30} color={`rgba(144, 202, 249,1)`}/> },

];

export default function CategoryCard4() {
  const [index, setIndex] = useState(0);


const handlePrev = () => {
setIndex((prev) => (prev === 0 ? classesData.length - 1 : prev - 1));
};


const handleNext = () => {
setIndex((prev) => (prev === classesData.length - 1 ? 0 : prev + 1));
};
  return (<>
    <section className="pop-sec-catc-4"><div className='pop-sec-catc-4-inn'>
        <div>

<h2 className="sec-title">OUR POPULAR CLASSES</h2>
</div>
</div>

<div className="slider-wrapper">
<button className="nav-btn prev" onClick={handlePrev}>◀</button>
<div className="continent-grid-catc-4">
{classesData.map(c => (
          <div
            key={c.id}
           
          >
<div className="triangle-card">

<div className="overlay">
<h4>{c.title}</h4>
{c.icon}
</div>
</div>
</div>))}
</div>
<button className="nav-btn next" onClick={handleNext}>▶</button>
</div>
<div className='pop-sec-catc-4-inn'>
     <button className="view-btn-catc-4"><span className='view-btn-catc-4-two'>View All Courses <ChevronRight  size={20} /></span></button>
  
</div>
     
</section>
    <style>{`/* File: PopularClassesSlider.css */

.view-btn-catc-4-two{display: flex;
  gap: 10px;
  justify-content: space-between;}
  
.view-btn-catc-4 { 
  background: rgba(144, 202, 249,1);
  border: none;
  padding: 12px 28px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: .3s;
}

.view-btn-catc-4:hover {
  background: #000;
  color: #fff;
}
.pop-sec-catc-4{margin-top:50px;}
.pop-sec-catc-4-inn{display: flex; justify-content: center;}
.continent-grid-catc-4 {
  display: flex;
  gap: 30px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 35px;
}
.slider-wrapper {
display: flex;
align-items: center;
justify-content: center;
position: relative;
gap: 10px;
}


.nav-btn {
background: var(--red);
border: none;
color: #fff;
width: 45px;
height: 45px;
border-radius: 50%;
cursor: pointer;
font-size: 20px;
transition: 0.3s;
}


.nav-btn:hover {
background: #ff2b57;
}


.triangle-card {
width: 200px;background:rgba(144, 202, 249,1);
height: 200px;
position: relative;
clip-path: polygon(50% 100%, 0 0, 100% 0);
overflow: hidden;
transition: 0.4s ease;
border: 3px solid var(--red);
}


.triangle-card img {
width: 100%;
height: 100%;
object-fit: cover;
}


.overlay {
position: absolute;
bottom: 0;
width: 100%;
text-align: center;
font-weight: 700;
padding: 10px 0;
background: rgba(0,0,0,0.55);
}

.triangle-card:hover .overlay { transition: height 0.4s ease;
height:160px;}
.triangle-card .overlay { transition: height 0.4s ease;
height:130px;}
.overlay h4 {
font-size: 16px;
}


@media (max-width: 768px) {
.slider-wrapper {
display: block;
gap: 0px;
}
.continent-grid-catc-4 {
 
  gap: 15px;display:flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.triangle-card {
width: 150px;
height: 180px;
}
.nav-btn {
width: 40px;
height: 40px;
}
}`}</style>
    </>
  );
}
